import { watch, type ComputedRef, type WatchHandle } from "vue";
import model from "../model";
import { getApp } from "../management/app-management";
import type { MainModel } from "../types/main-model";
import { appHeaderAdvertDisplayed } from "../management/ui-management";

type GlobalDirectiveProps = {
    name: string,
    datasetName: string,
    // modelPropName?: keyof MainModel,
    // compProp?: ComputedRef<boolean>,
    watchHandle: () => unknown,
};

export function defineGlobalDirectives(){
    const unwatchers = new Map<HTMLElement, WatchHandle[]>();

    const app = getApp();
    if(!app) return;

    const list: GlobalDirectiveProps[] = [
        {
            name: 'mobile',
            datasetName: 'mobile',
            watchHandle: () => model.isMobile,
        },
        {
            name: 'is-app',
            datasetName: 'isApp',
            watchHandle: () => model.isApp,
        },
        {
            name: 'is-modal-displayed',
            datasetName: 'modalDisplayed',
            watchHandle: () => model.activeModal,
        },
        {
            name: 'has-app-header-advert',
            datasetName: 'headerAdvertDisplayed',
            watchHandle: () => appHeaderAdvertDisplayed.value,
        },
    ];

    list.forEach(item => {
        app.directive(item.name, {
            unmounted(element){
                unwatchers.get(element)?.forEach(unwatch => unwatch());
                unwatchers.delete(element);
            },
            mounted(element: HTMLElement){
                let unwatch = watch(item.watchHandle, value => {
                    if(value) element.dataset[item.datasetName] = 'true';
                    else delete element.dataset[item.datasetName];
                }, {immediate: true});
                if(!unwatchers.has(element)) unwatchers.set(element, []);
                unwatchers.get(element)?.push(unwatch);
            },
        });
    });
}